import React, { PropsWithChildren } from "react";
import { PillProps } from "./types";
import classNames from "classnames";

export const Pill: React.FC<PropsWithChildren<PillProps>> = ({
  children,
  selected,
  onClick,
  className,
  noHover,
}) => {
  return (
    <label
      className={classNames(
        className,
        !noHover &&
          "hover:bg-[--milkylb-color-secondary-200] hover:text-[--milkylb-color-neutral-100]",
        "cursor-pointer	rounded-2xl px-3 py-1.5 text-sm transition-all",
        selected
          ? "bg-[--milkylb-color-secondary-200] text-[--milkylb-color-neutral-100]"
          : "bg-[--milkylb-color-background-input] text-[--milkylb-color-secondary-200]",
      )}
      onClick={onClick}
    >
      {children}
    </label>
  );
};
